<template>
  <button
    type="button"
    aria-label="Back"
    class="back-button"
  >
    <v-icon icon="$arrow-left" :size="20" />
  </button>
</template>

<style lang="less" scoped>
.back-button {
  border-radius: 8px;
  padding: 4px;

  :deep(svg path) {
    fill: @icon-dark;
  }

  &:hover {
    background-color: @bg-dark;

    :deep(svg path) {
      fill: @icon-brand;
    }
  }
}
</style>
